




















import storeHelper from "../../store/store-helper";
import { Portal, SearchFeedbackPost } from "@infoland/iprova-api";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../dialogs/ZenyaDialog.vue";
import { SnackBarTimeout } from "@/enums";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "AddSearchFeedback",
    components: {},
    props: {
        searchText: String,
        portal: Object as () => Portal
    },
    data: function () {
        return {
            submitting: false,
            feedback: ""
        };
    },
    created() {
        //register handler for dialog OK button
        this.registerHandlers({ ok: this.sendFeedback });
    },
    computed: {
        instructionText(): string {
            return this.portal.search_feedback_instruction;
        }
    },
    methods: {
        required() {
            return v => !!v || `${this.$t("general.validation.isRequired")}`;
        },
        validateForm() {
            const formIsValid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
            if (!formIsValid) ((this.$refs.feedbackText as Vue).$refs.input as HTMLFormElement).focus();
            return formIsValid;
        },
        async sendFeedback(): Promise<boolean> {
            if (this.validateForm()) {
                this.submitting = true;

                const searchFeedback: SearchFeedbackPost = {
                    portal_id: this.portal.portal_id,
                    search_text: this.searchText,
                    number_of_results: storeHelper.contentItemsStore.numberOfAvailableContentItems,
                    expected_results: this.feedback
                };
                const result = await storeHelper.searchFeedbackStore.createSearchFeedbackAsync(searchFeedback);
                this.submitting = false;
                if (result) {
                    storeHelper.siteStore.setSnackBarMessage(this.$t("searchFeedback.successfullyReceived").toString(), false, SnackBarTimeout.short);
                    //revert input
                    this.feedback = "";

                    return true; //closes dialog
                } else {
                    storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
                }
            }

            return false; //keep dialog opened
        }
    }
});
